import React from 'react';
import { toast } from 'react-toastify';
import { ReactComponent as IconInfo } from '../../../assets/colored/ic-colored-info.svg';
import { ReactComponent as StopperIcon } from '../../../assets/shared/ic-shared-stopper.svg';
import { ReactComponent as IconVMark } from '../../../assets/shared/ic-shared-checkmark-circle.svg';
import { ReactComponent as ErrorIcon } from '../../../assets/shared/ic-shared-error-triangle.svg';
import { CloseButton } from '../LiliCloseButton/CloseButton';
import { FontWeight, Text } from '../../tokens';

export enum LiliNotificationType {
  INFORMATIONAL,
  WARNING,
  SUCCESS,
  ERROR,
  CUSTOM,
}
export interface LiliNotificationProps {
  title?: string;
  text: string;
  id: string;
  type?: LiliNotificationType;
  undismissable?: boolean;
  onClose?: () => void;
  customIcon?: React.ReactNode;
  dataTestId?: string;
}

export const LiliNotification = (props: LiliNotificationProps) => {
  const {
    title,
    text,
    id,
    type = LiliNotificationType.INFORMATIONAL,
    undismissable,
    onClose,
    customIcon,
    dataTestId,
  } = props;

  const getClassNameByType = () => {
    switch (type) {
      case LiliNotificationType.INFORMATIONAL:
      case LiliNotificationType.CUSTOM:
        return 'border-outline-brand-primary';
      case LiliNotificationType.WARNING:
        return 'border-outline-amber-primary';
      case LiliNotificationType.SUCCESS:
        return 'border-outline-positive-primary';
      case LiliNotificationType.ERROR:
        return 'border-outline-negative-primary';
      default:
        return '';
    }
  };

  const getIconByType = () => {
    switch (type) {
      case LiliNotificationType.INFORMATIONAL:
        return <IconInfo />;
      case LiliNotificationType.WARNING:
        return <StopperIcon className='text-text-badge-amber' />;
      case LiliNotificationType.SUCCESS:
        return <IconVMark className='text-text-badge-green' />;
      case LiliNotificationType.ERROR:
        return <ErrorIcon className='text-text-negative-red' />;
      case LiliNotificationType.CUSTOM:
        return customIcon || <IconInfo />;
      default:
        return '';
    }
  };

  const handleClose = () => {
    onClose && onClose();
    toast.dismiss();
  };

  return (
    <div
      id={id}
      data-testid={dataTestId}
      className={`w-[467px] bg-surface-primary-bw-00 flex justify-between flex-row gap-[8px] items-center border-[1px] rounded-lg px-[12px] py-[10px] ${getClassNameByType()}`}>
      <div className='flex flex-row gap-[8px] items-center'>
        <div>{getIconByType()}</div>
        <div className='flex flex-col'>
          {title && (
            <Text.H10 fontWeight={FontWeight.SEMIBOLD} className='flex flex-grow-1'>
              {title}
            </Text.H10>
          )}
          <Text.H10 className='flex flex-grow-1'>{text}</Text.H10>
        </div>
      </div>
      {!undismissable && <CloseButton id='close-notification' onClick={handleClose} />}
    </div>
  );
};
